import { __decorate, __metadata } from "tslib";
import { DefaultExposeGroupEnum, IsNotEmptyObjectWithLVS } from '@goparrot/common';
import { Expose } from 'class-transformer';
import { IsArray, IsInt, IsOptional, IsPositive } from 'class-validator';
export class ApplySpendRuleDto {
}
__decorate([
    Expose({ groups: [DefaultExposeGroupEnum.READ] }),
    IsOptional({ always: true }),
    IsArray({ always: true }),
    IsNotEmptyObjectWithLVS({ always: true, each: true }),
    __metadata("design:type", Array)
], ApplySpendRuleDto.prototype, "storeItems", void 0);
__decorate([
    Expose({ groups: [DefaultExposeGroupEnum.READ] }),
    IsOptional({ always: true }),
    IsInt({ always: true }),
    IsPositive({ always: true }),
    __metadata("design:type", Number)
], ApplySpendRuleDto.prototype, "quantity", void 0);
//# sourceMappingURL=ApplySpendRuleDto.js.map